<app-upsell-card
  htmlTitle="<strong>Support</strong> Hair Strength with Biotin"
  question="We strongly recommend including a biotin supplement with your prescription. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    <strong>Biotin</strong> is an essential nutrient that supports keratin production - the protein that makes up your
    hair. <strong>Low or suboptimal biotin levels can contribute to brittle, thinning hair and slower growth.</strong>
  </p>
  <p class="mb-4">
    Adding a biotin supplement helps support
    <strong>stronger strands, improved hair thickness, and healthier growth</strong> when used alongside your hair loss
    treatment.
  </p>
  <p class="mb-4">This option offers a simple, well-tolerated way to support hair quality and maximize your results.</p>
</app-upsell-card>
